import { useLocation } from "react-router-dom";

export const useNavigation = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const isItemActive = (item) => {
    const linkPath = (item.link || "").toLowerCase();
    const matchesLink =
      linkPath &&
      (currentPath === linkPath || currentPath.startsWith(linkPath));

    if (matchesLink) return true;
    if (item.subItems && item.subItems.length > 0) {
      return item.subItems.some((child) => isItemActive(child));
    }
    return false;
  };

  return { currentPath, isItemActive };
};
